import { gql } from '@apollo/client';

export const UPDATE_BULLETIN_MUTATION = gql`
  mutation updateBulletin($input: UpdateBulletinInput!) {
    updateBulletin(input: $input) {
      bulletin {
        details
        discussion
        id
        message
        officerId
        priority
        unread
      }
      clientMutationId
      errors
    }
  }
`

//Example input:
// {
//   "input": {
//    "userId": 3472, 
//     "bulletinId": 66,
//     "seen": true,
//     "comment": "This is a comment set in GraphiQL",
//     "clientMutationId": "clientMutationId as a string"
//   }
// }